import customFetch from "~/composables/custom-fetch";
import serverConfig from '~/server/config';
import useAccountStore from "~/shared/store/modules/account";
import useCompaniesStore from "~/shared/store/modules/account/companies";
import type {IProfile} from "~/shared/interfaces/account";

async function getUserProfile() {
  const accountStore = useAccountStore()
  const companiesStore = useCompaniesStore()
  const token = useCookie('token')

  if (token.value) {
    const { account } = serverConfig
    const { data: profile } = await customFetch<IProfile>(account.getAccountProfile())

    if (profile) {
      accountStore.setUserProfile(profile)

      if (profile.permission.find(el => el.slug === 'viewNova')) {
        accountStore.setUserRole('admin')
      } else {
        accountStore.setUserRole('regular')
      }

      const { data } = await useFetch('/api/account/getAccountCompanies', {headers: {'Cache-Control': 'no-cache'}, getCachedData() {
          return null
        }});

      if(data.value && data.value.length > 0 && Array.isArray(data.value)) {
        companiesStore.setCompaniesList(data.value)
      }

      return;
    }
  }
  accountStore.setUserRole('guest')
}

export default getUserProfile;
